/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

Odigeo.defineWidget('membership_manager', Odigeo.Widget.extend({

    modelClass: require('./model'),
    viewClass: require('./view'),

    init: function() {},

    exposedMethods: {
        getUserType: 'model.getUserType',
        addMembership: 'model.addMembership',
        setPriceSelected: 'model.setPriceSelected',
        disableAutoRenewal: 'model.disableAutoRenewal',
        enableAutoRenewal: 'model.enableAutoRenewal',
        getSubscriptionDetails: 'model.getSubscriptionDetails',
        getRenewalStatus: 'model.getRenewalStatus',
        getSubscriptionOffer: 'model.getSubscriptionOffer',
        getTokenInfo: 'model.getTokenInfo',
        getMembership: 'model.getMembership',
    },

    execute: function(func) {
        return Odigeo.Utils.executeInternalMethods(this, this.exposedMethods, func, Odigeo._.rest(arguments));
    },
}));
